<template>
  <span>
    <!-- Drawer principal -->
    <v-navigation-drawer
      color="greyen"
      class="scroll-bar navigation"
      clipped
      fixed
      permanent

      :right="positionRight"
      :key="reload"
      :width="width"

    >
      <!-- HEADER del drawer -->
      <template v-slot:prepend>
        <v-container>
          <slot name="back-nav">
            <v-btn large text @click="handleRouteBack" class="pl-1">
              <v-icon>mdi-arrow-left</v-icon>
              <span class="ml-4 font-weight-medium" style="font-size: 15px">
                Productos de la empresa
              </span>
            </v-btn>
          </slot>

          <slot name="breadcrumbs" />
          <div class="mt-5 pa-0">
            <div class="estilo-subheader">
              <slot name="up-title" />
            </div>
          </div>
          <slot name="title">TITLE</slot>
        </v-container>
      </template>

      <!-- CONTENIDO DEL DRAWER -->
      <slot name="navigation-controller" :reload="reloadNav">
        <div id="aca"></div>
      </slot>

      <!-- FOOTER del drawer -->
      <template v-slot:append>
        <div class="pa-2">
          <slot name="navigation-stepper" />
        </div>
        <v-card>
          <v-container>
            <v-row>
              <v-col>
                <v-row class="mt-1">
                  <v-col>
                    <slot name="navigation-append" :reload="reloadNav" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </template>
    </v-navigation-drawer>

    <!-- CONTENIDO PRINCIPAL -->
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <slot name="vista-previa" />

            <v-row>
              <v-col>
                <v-list style="background-color: transparent" flat two-line>
                  <v-list-item style="padding-left: 0px">
                    <v-list-item-content>
                      <v-list-item-title>
                        <div class="title">
                          <slot name="vista-previa-title" />
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <slot name="vista-previa-action" />
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <slot name="vista-previa-list" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>

    <!-- SEGUNDO DRAWER (opcional) -->
    <v-navigation-drawer
      v-if="navigationSecond"
      width="360"
      color="#1E1E1E"
      class="items3"
      fixed
      floating
      clipped
      app
      id="nav-2"
      :right="!positionRight"
      :key="reloadSecond"
    >
      <template v-slot:prepend>
        <v-container>
          <slot name="breadcrumbs" />
          <div class="mt-5 pa-0">
            <div class="estilo-subheader">
              <slot name="up-title-second">Compras</slot>
            </div>
          </div>
          <slot name="title-second" />
        </v-container>
      </template>

      <slot name="navigation-controller-second" :reloadSecond="reloadNav">
        <div id="aca"></div>
      </slot>

      <template v-slot:append>
        <v-card>
          <v-container>
            <v-row>
              <v-col>
                <slot name="navigation-stepper-second" />
                <v-row class="mt-1">
                  <v-col>
                    <slot name="navigation-append-second" :reloadSecond="reloadNav" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </template>
    </v-navigation-drawer>
  </span>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  name: "layout.registrar.producto",
  components: {},
  props: {
    expandOnHover: {
      type: Boolean,
      required: false,
      default: false,
    },
    positionRight: {
      type: Boolean,
      required: false,
      default: false,
    },
    navigationSecond: {
      type: Boolean,
      required: false,
      default: false,
    },
    width: {
      type: String,
      required: false,
      default: "360",
    },
    routeBack: {
      type: String | Object | Number,
      required: false,
    },
  },
  data() {
    return {
      item: 0,
      reload: 0,
      reloadSecond: 1,

      openDrawer: true,
      duration: 300,
      offset: 0,
    };
  },

  methods: {
    handleRouteBack() {
      console.log(this.routeBack);
      
      if (typeof this.routeBack === "object" && this.routeBack !== null) {
        const routeName = this.routeBack.name;
        this.$router.push({ name: routeName });
        // Si routeBack es un objeto, utiliza el nombre de la ruta
      } else if (typeof this.routeBack === "string") {
        // Si routeBack es una cadena, utiliza la ruta directamente
        this.$router.push(this.routeBack);
      } else if (typeof this.routeBack === "number") {
        // Si routeBack es una number
        this.$router.go(-1);
      }
      // Puedes agregar más lógica según tus necesidades
    },
    reloadNav() {
      this.reload = !this.reload;
    },
  },

  created() {},
};
</script>

<style scoped>
.custom-main {
  padding: 0px 0px 0px 360px !important;
}

/* Estilos para pantallas pequeñas y tabletas */
@media (max-width: 960px) {
  .custom-main {
    padding: 0px !important; /* Ajusta el padding a 0 en todas las direcciones */
  }
}
.navigation {
  top: 64px !important;
  height: 100% !important;
  max-height: calc(100% - 64px);
}

.estilo-subheader {
  word-break: break-word;
  color: #b0b3b8;
  font-size: 0.9125rem;
}
.items3:hover ::-webkit-scrollbar {
  width: 8px !important;
}
.items3 ::-webkit-scrollbar {
  width: 0px;
  height: 18px;
}
.items3 ::-webkit-scrollbar-track {
  background: transparent;
}
.items3 ::-webkit-scrollbar-thumb {
  background: #888;
}
</style>

